'use client';

import { ChipTheme } from '@shared/ui-components';

import { type LocalPaths } from '../../../../utils/data/get-local-paths';
import { useBreakpoint } from '../../../../utils/hooks/use-breakpoint';
import { useIsHeaderSecondaryTheme } from '../../utils/hooks';
import { Chip } from '../../../chip';

type StatusChipClientProps = {
  label?: string;
  paths: LocalPaths;
  url: string;
};

export const StatusChipClient = ({ label, paths, url }: StatusChipClientProps) => {
  const isSecondaryTheme = useIsHeaderSecondaryTheme({ paths });
  const { breakpoint, isDesktop } = useBreakpoint();

  if (!label) {
    return null;
  }

  return (
    <Chip
      label={label}
      theme={
        isSecondaryTheme && (isDesktop || breakpoint === undefined) ? undefined : ChipTheme.Light
      }
      to={url}
    />
  );
};
